import React, { useState } from 'react';
import type { VariableSpec } from '@/shared/warnings/types';

type Props = {
  open: boolean;
  variable?: VariableSpec | null;
  onClose: () => void;
  onSave: (value: any, variable: VariableSpec) => Promise<void> | void;
};

const QuickEditDialog: React.FC<Props> = ({ open, variable, onClose, onSave }) => {
  const [value, setValue] = useState<any>('');

  if (!open || !variable) return null;

  const handleSave = async () => {
    await onSave(value, variable);
  };

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
    }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: 16, width: 360 }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Update {variable.label}</div>
        <input data-testid="components-warnings-quick-edit-dialog-input-action"
          aria-label={`Edit ${variable.label}`}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc' }}
        />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
          <button onClick={onClose} style={{ padding: '6px 12px' }}>Cancel</button>
          <button onClick={handleSave} style={{ padding: '6px 12px', background: '#155f54', color: '#fff', borderRadius: 6 }}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default QuickEditDialog;


